import { useAuthUserContext } from 'src/providers/User/AuthUserContext';

export const useLoggedInUser = () => {
  const { user } = useAuthUserContext();
  return user;
};
